import React, { useContext } from 'react';
import { AddCouponFormContext } from '../../../Context/Coupons/AddCouponFormContext';
import { useDispatch } from 'react-redux';
import { setModal } from '../../../Features/couponsSlice';

function SelectedCategoryCollection() {
    const dispatch = useDispatch();

    const { selectedCategory, setSelectedCategory, selectedCollection, setSelectedCollection, setSelectionType } = useContext(AddCouponFormContext);

    const handleRemoveCollection = () => {
        setSelectedCategory({});
        setSelectedCollection({});
        setSelectionType('');
    }

    const handleReplaceCollection = () => {
        dispatch(setModal('select-category-collection'));
    }

    return (
        <div className="border border-[#EAEAEA] rounded-xl p-5 flex flex-col gap-3">
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>Category Collection</h1>
            
                <div className="flex items-center gap-5">
                    <button onClick={handleRemoveCollection} className='font-inter font-medium text-[16px] leading-5 text-[#EF4444]'>Remove</button>

                    <button onClick={handleReplaceCollection} className='font-inter font-medium text-[16px] leading-5 text-primaryColor'>Replace</button>
                </div>
            </div>

            <div className="border border-[#EAEAEA] rounded-lg bg-[#F5F5F5] px-[10px] py-2">
                <p className='font-semibold text-base text-[#121212]'>{selectedCategory.categoryName} {'>'} {selectedCollection.CollectionName}</p>
            </div>
        </div>
    );
}

export default SelectedCategoryCollection;
